import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ChevronUpIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M2.24 17.5 12 7.99l9.76 9.51.74-.73L12 6.5 1.5 16.77l.74.73Z" />
  </IconWrapper>
)

export default ChevronUpIconMedium
